import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DS2 from '../../components/ExcerciseTypes/Design/Select'


const json = {

    1: { // Exercise num
        unit: 'Starter',
        id: 'SB4-S-P4-E1',
        audio: 'img/FriendsPlus/Page4/Audio/audio-e1-p4.mp3',
        video: '',
        recorder: true,
        checkUppercase: true,
        component: UI,
        isAllowSubmit: false,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page4/E1/1.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/tieude-e1-p4.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/3.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page4/E1/4.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/5.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/grandma.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/6.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/7.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/grandpa.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/8.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/9.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/mom.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/10.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/11.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/dad.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/12.jpg' },
            ],
            [
                // Column1
                { url: 'img/FriendsPlus/Page4/E1/13.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page4/E1/14.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/15.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/aunt.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/16.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/17.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/uncle.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/18.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/19.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/brother.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/20.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/21.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/sister.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/22.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/23.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/cousin.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/24.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page4/E1/25.jpg' }
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page4/E1/26.jpg' },
                // { url: 'img/FriendsPlus/Page4/E1/27.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh-max-e3-p4.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/27.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/28.jpg' },
                // { url: 'img/FriendsPlus/Page4/E1/29.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh-holly-e3-p4.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/29.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/30.jpg' },
                // { url: 'img/FriendsPlus/Page4/E1/31.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh-Amy-e3-p4.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/31.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/32.jpg' },
                // { url: 'img/FriendsPlus/Page4/E1/33.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh-Leo-e3-p4.mp3' },
                { url: 'img/FriendsPlus/Page4/E1/33.jpg' },
                { url: 'img/FriendsPlus/Page4/E1/34.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page4/E1/35.jpg' }
            ],
        ],
    },
    2: { // Exercise num
        unit: 'Starter',
        id: 'SB4-S-P4-E2',
        audio: '',
        video: '',
        component: D1,
        exerciseKey: 'img/FriendsPlus/Page4/E2/Key/answerKey.png',
        padding: 0,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page4/E2/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page4/E2/2.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page4/E2/3.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/4.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/5.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/6.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/7.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/8.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/9.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/10.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/11.jpg' },
            ],
            [
                // Column1
                { url: 'img/FriendsPlus/Page4/E2/12.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page4/E2/13.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/14.jpg', input: true, answer: "Amy" },
                { url: 'img/FriendsPlus/Page4/E2/15.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/16.jpg', input: true, answer: "Holly" },
                { url: 'img/FriendsPlus/Page4/E2/17.jpg' },
                { url: 'img/FriendsPlus/Page4/E2/18.jpg', input: true, answer: "Max" },
                { url: 'img/FriendsPlus/Page4/E2/19.jpg' },
            ],
            [
                // Column1
                { url: 'img/FriendsPlus/Page4/E2/20.jpg' },
            ],
        ],
    },
    3: { // Exercise num
        unit: 'Starter',
        id: 'SB4-S-P4-E3',
        audio: '',
        video: '',
        component: DS2,
        fontSize: 20,
        exerciseKey: 'img/FriendsPlus/Page4/E3/Key/answerKey.png',
        titleQuestion: [{ num: '3', title: 'Listen and check. <headphone name="02" src="img/FriendsPlus/Page4/Audio/tieude-e3-p4.mp3"></headphone>  ' }],
        titleImage: '',
        questionImage: [
            [
                // Column1
                { url: 'img/FriendsPlus/Page4/E3/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page4/E3/2.jpg' },
                { url: 'img/FriendsPlus/Page4/E3/3.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh-max-e3-p4.mp3' },
                { url: 'img/FriendsPlus/Page4/E3/4.jpg' },
                { url: 'img/FriendsPlus/Page4/E3/5.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh-holly-e3-p4.mp3' },
                { url: 'img/FriendsPlus/Page4/E3/6.jpg' },
                { url: 'img/FriendsPlus/Page4/E3/7.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh-Amy-e3-p4.mp3' },
                { url: 'img/FriendsPlus/Page4/E3/8.jpg' },
                { url: 'img/FriendsPlus/Page4/E3/9.jpg', audioUrl: 'img/FriendsPlus/Page4/Audio/anh-Leo-e3-p4.mp3' },
                { url: 'img/FriendsPlus/Page4/E3/10.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page4/E3/11.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page4/E3/12.jpg' },
                { url: 'img/FriendsPlus/Page4/E3/13.jpg', input: true, answer: "Amy" },
                { url: 'img/FriendsPlus/Page4/E3/14.jpg' },
                { url: 'img/FriendsPlus/Page4/E3/15.jpg', input: true, answer: "Holly" },
                { url: 'img/FriendsPlus/Page4/E3/16.jpg' },
                { url: 'img/FriendsPlus/Page4/E3/17.jpg', input: true, answer: "Max" },
                { url: 'img/FriendsPlus/Page4/E3/18.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page4/E3/19.jpg' },
            ],


        ],
        questions: [
            {
                // title: 'The dictionaries are # the shelf',
                // answer: ['table']
            },
        ]
    },

}

export default json;